export const LECTURE_LOGGING_API = '/api/membership/lecture'

export const SESSION_LOGGING_API = '/api/membership/lecture/session'

export enum TrackingApi {
  InitLecture = '/api/membership/lecture',
  UpdateLecture = '/api/membership/lecture/session',
  InitQuiz = '/api/membership/quiz',
  UpdateQuiz = '/api/membership/quiz/session',
}
